import {useContainerBreakpoint} from "@project/layouts";
import {Navigate, createFileRoute} from "@tanstack/react-router";
import {useRef} from "react";

export const Route = createFileRoute("/_app/sales/offers/templates/$offerTemplateId/")({
  component: IndexComponent,
});
function IndexComponent() {
  const {offerTemplateId} = Route.useParams();
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);
  if (isDesktop)
    return (
      <Navigate
        replace
        to="/sales/offers/templates/$offerTemplateId/preview"
        params={{offerTemplateId}}
      />
    );
  return <div ref={ref} className="h-full w-full" />;
}
